import { render } from "./StaffDetail.vue?vue&type=template&id=f89b3b0a&scoped=true"
import script from "./StaffDetail.vue?vue&type=script&lang=js"
export * from "./StaffDetail.vue?vue&type=script&lang=js"

import "./StaffDetail.vue?vue&type=style&index=0&id=f89b3b0a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/zamon-vue/zamon-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f89b3b0a"]])

export default __exports__